import React from "react";

function Header() {
    return (
        <div className="App">
            Employee Directory
            <header className="App-header">


            </header>
        </div>
    )
}

export default Header;